import Vue from 'vue';
import SentryInit from '@src/sentry';
import BookingEngine from '@liveflight/components/blocks/booking-engine/booking-engine.vue';
import BtnBack from '@liveflight/components/atoms/btn-back.vue';
import Chevron from '@/components/blocks/chevron.vue';
import { get_config } from '@/utilities';
import { are_services_present, is_service_present } from '@/services';
import { bootstrap_providers } from '@liveflight/providers';

const initialize_providers = () => {
  const base_providers_config = {
    amadeus: {
      enabled: true,
      capabilities: { automatedCheckIn: is_service_present('checkinOffer') },
    },
    kyte: {
      enabled: are_services_present(
        ['search', 'retrieve', 'book', 'checkout'].map(
          (service) => `kyte.${service}`
        )
      ),
    },
  };
  bootstrap_providers(get_config('providers', base_providers_config));
};

// site specific components and settings
export default function site_config() {
  Vue.component('booking-engine', BookingEngine);
  Vue.component('chevron', Chevron);
  Vue.component('button-back', BtnBack);

  window.eventBus.$on('endpoints:ready', initialize_providers);
  SentryInit();
  initialize_providers();
}
